<script>
  import { createEventDispatcher } from 'svelte';
  import { apiServer } from '../../helpers/host-sniffer';
  import { fade } from 'svelte/transition';

  const dispatch = createEventDispatcher();

  export let loginFailed;

  let key;

  async function handleSubmit(e) {
    e.preventDefault();
    dispatch('handleLogin', key);
  }
</script>

<!-- Login Form -->
<div class="w-full max-w-xs mx-auto" style="margin-top:40vh" transition:fade>
  <form class="bg-gray-800 shadow-md rounded-lg px-8 pt-6 pb-8 mb-4" on:submit="{handleSubmit}">
    <!-- Key input -->
    <div class="mb-4">
      <label class="block text-white text-sm font-bold mb-1" for="key">Enter key</label>
      <input
        class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight
        focus:outline-none focus:shadow-outline"
        id="key"
        type="text"
        spellcheck="false"
        bind:value="{key}" />
    </div>

    <!-- Validation failed -->
    {#if loginFailed}
      <h2 class="text-red-600 font-bold my-4">This key is invalid.</h2>
    {/if}

    <!-- Submit button -->
    <div class="flex items-center justify-between">
      <button
        class="bg-gray-900 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded
        focus:outline-none focus:shadow-outline"
        type="submit">
        Sign In
      </button>
    </div>
  </form>
  <p class="text-center text-gray-500 text-xs">&copy; 2020 Codepilot, Inc. All rights reserved.</p>
</div>
